import { Epic } from 'redux-observable';
import { filter, ignoreElements, tap, withLatestFrom } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { ActionType, ActionTypes } from '../actionTypes';
import { RootState } from '../types';
import { persistState, StorageTypes } from '../../utils/persistentState';

const storeActiveMarkerEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.SET_ACTIVE_MARKER])),
    withLatestFrom(state$),
    tap(([action]) => {
      const activeMarker = action.payload;
      persistState(activeMarker, StorageTypes.ActiveMarker);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

const storeMotionThresholdEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.SET_MOTION_THRESHOLD])),
    withLatestFrom(state$),
    tap(([action]) => {
      const motionThreshold = action.payload;
      persistState(motionThreshold, StorageTypes.MotionThreshold);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

const storeSelectedHoursEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.SET_SELECTED_HOURS])),
    withLatestFrom(state$),
    tap(([action]) => {
      const selectedHours = action.payload;
      persistState(selectedHours, StorageTypes.SelectedHours);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

const storeSortByEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.SET_SORT_BY])),
    withLatestFrom(state$),
    tap(([action]) => {
      const sortBy = action.payload;
      persistState(sortBy, StorageTypes.SortBy);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

const storeShowHelpEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.SHOW_HELP])),
    withLatestFrom(state$),
    tap(([action]) => {
      const showHelp = action.payload;
      persistState(showHelp.toString(), StorageTypes.ShowingHelp);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

const storeThemeModeEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.SET_THEME_MODE])),
    withLatestFrom(state$),
    tap(([action]) => {
      const themeMode = action.payload;
      persistState(themeMode, StorageTypes.ThemeType);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

const storePlotVarsEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.TOGGLE_ACTIVE_PLOT_VAR])),
    withLatestFrom(state$),
    tap(([, state]) => {
      // use updated state to store
      const plotVars = state.uiSettings.activePlotVars;
      persistState(plotVars, StorageTypes.PlotVars);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

const storeDashboardPanelEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.TOGGLE_DASHBOARD_PANEL, ActionType.SET_DASHBOARD_PANEL])),
    withLatestFrom(state$),
    tap(([, state]) => {
      // use updated state to store
      const panel = state.uiSettings.dashboardPanels;
      persistState(panel, StorageTypes.DashboardPanels);
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

export {
  storeActiveMarkerEpic,
  storeMotionThresholdEpic,
  storeSelectedHoursEpic,
  storeSortByEpic,
  storeShowHelpEpic,
  storeDashboardPanelEpic,
  storeThemeModeEpic,
  storePlotVarsEpic,
};
